<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";
import ACText from '../../../partials/ACTextArea/index.vue'
export default {
  name: "MyConfirmModal",
 
    components: {
    "text-area": ACText,
  },
  props: {
    visible: Boolean,
    title: String,
    content: String,
    askReason: Boolean,
    initialReason: String,
  },
  data() {
    
    return {
      modalVisible: false,
      reason: null,
      data:true,
    };
  },
  methods: {

    handle(param){
    console.log(param,'fasdfdsa');
    this.reason = param
    },
    updateHandle(){

    },
    handleOk() {
      if (this.askReason && (!this.reason || this.reason.trim().length == 0)) {
       
        this.$message.error("Qeyd mütləq daxil edilməlidir.");
        return;
      }
      this.$emit("onOk", this.reason);
    },
    handleCancel() {

      this.$emit("afterClose");
    },
  },
  watch: {
    visible: function (newValue, oldValue) {
      //console.log(newValue);
      this.modalVisible = this.visible;
      if (newValue && !oldValue) {
        this.reason = this.initialReason;
      }
    },
   
    modalVisible: function () {
      
      if (!this.modalVisible) {
        this.reason=null;
        this.data=false;
        this.$emit("afterClose");

      }
      else{
         this.data=true;
      }
    },
  },
  created() {
    this.modalVisible = this.visible;
    this.reason = this.initialReason;
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
